import './form-input.scss';
type FormInputProps = {
  label: string;
  id: string;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value?: string;
};

const FormInput = ({
  label,
  id,
  name,
  placeholder,
  value,
  onChange,
}: FormInputProps) => {
  return (
    <div className="input-text-container">
      <img className="qt-mark" src="images/infor/question-mark.svg" alt="" />
      <label htmlFor={id}>{label}</label>
      <input
        placeholder={placeholder}
        autoComplete="off"
        type="text"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default FormInput;
